import React from 'react';
import { Receipt, Building2, FileSpreadsheet, Landmark, HelpCircle } from 'lucide-react';

export interface DocumentTypeBadgeProps {
  type: string | null;
  confidence: number | null;
}

export const DocumentTypeIcon: React.FC<{ type: string | null }> = ({ type }) => {
  switch (type) {
    case 'K1':
      return <Receipt className="w-5 h-5" style={{ color: 'var(--color-needs-human-text)' }} />;
    case '1065':
      return <Building2 className="w-5 h-5" style={{ color: 'var(--color-needs-human-text)' }} />;
    case 'PL':
      return <FileSpreadsheet className="w-5 h-5" style={{ color: 'var(--color-verified)' }} />;
    case 'BANK':
      return <Landmark className="w-5 h-5" style={{ color: 'var(--color-brand)' }} />;
    default:
      return <HelpCircle className="w-5 h-5" style={{ color: 'var(--color-text-dim)' }} />;
  }
};

export const DocumentTypeBadge: React.FC<DocumentTypeBadgeProps> = ({ type, confidence }) => {
  const getTypeInfo = (): { label: string; style: React.CSSProperties } => {
    switch (type) {
      case 'K1':
        return { label: 'Schedule K-1', style: { backgroundColor: 'var(--color-needs-human-tint)', color: 'var(--color-needs-human-text)', borderColor: 'var(--color-needs-human-tint-bd)' } };
      case '1065':
        return { label: 'Form 1065', style: { backgroundColor: 'var(--color-needs-human-tint)', color: 'var(--color-needs-human-text)', borderColor: 'var(--color-needs-human-tint-bd)' } };
      case 'PL':
        return { label: 'P&L Statement', style: { backgroundColor: 'transparent', color: 'var(--color-verified)', borderColor: 'var(--color-verified)' } };
      case 'BANK':
        return { label: 'Bank Statement', style: { backgroundColor: 'var(--color-needs-human-tint)', color: 'var(--color-brand)', borderColor: 'var(--color-needs-human-tint-bd)' } };
      default:
        return { label: 'Unknown', style: { backgroundColor: 'var(--color-bg-elevated)', color: 'var(--color-text-primary)', borderColor: 'var(--color-border)' } };
    }
  };

  const { label, style } = getTypeInfo();

  return (
    <div className="flex items-center gap-2">
      <span className="px-2 py-1 text-xs font-medium rounded-full border" style={style}>
        {label}
      </span>
      {confidence && (
        <span className="text-xs" style={{ color: confidence >= 0.8 ? 'var(--color-verified)' : confidence >= 0.6 ? 'var(--color-brand)' : 'var(--color-needs-human-text)' }}>
          {(confidence * 100).toFixed(0)}% confident
        </span>
      )}
    </div>
  );
};

export default DocumentTypeBadge;
